import { useIsBrowser } from 'util/useIsBrowser';
import styles from './styles.module.scss';
import summerStyles from './summer-styles.module.scss';

interface Props {
  title?:string;
  description?:string | {
    dangerouslySetInnerHTML: {
      __html: string;
    };
  }
  isSummerMode?: boolean;
}

export const SectionHeader = ({ title, description, isSummerMode = false }:Props) => {
  const isBrowser = useIsBrowser();

  const sectionHeaderStyles = isSummerMode ? summerStyles : styles;

  return (
    <>
      {title && <h3 className={sectionHeaderStyles.section_header}>{title}</h3>}
      {typeof description === 'string' && (
      <p className={sectionHeaderStyles.section_description}>
        {description}
      </p>
      )}
      {description && typeof description !== 'string' && isBrowser && (
      <div
        className={sectionHeaderStyles.section_description}
        dangerouslySetInnerHTML={description.dangerouslySetInnerHTML}
      />
      ) }
    </>
  );
};
